// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import {Link} from 'react-router-dom'

import ColorConstants from 'constants/ColorConstants'
import { getRelativeExcerptUrl } from '../mappers/ExcerptUrlMapper';
import { useTranscriptName } from 'hooks/transcripts/queries';

const TranscriptExcerptTitle = ({excerpt, onLinkClick}) => {
  // Use the useTranscript hook to fetch transcript data by ID
  const { data: transcript } = useTranscriptName(excerpt?.transcript_id);

  // Helper function to check if a string is null, empty, or only whitespace
  const isEmptyOrWhitespace = (str) => !str || str.trim().length === 0;

  // Apply fallback title
  const transcriptName = isEmptyOrWhitespace(transcript?.name) ? 'Untitled Transcript' : transcript.name;

  return (<p style={{fontSize:"0.8em"}}>
  <Link onClick={onLinkClick} to={getRelativeExcerptUrl(excerpt)}>
    <span style={{
      color:ColorConstants.ACTIVE_BUTTON_BLUE,
      display: 'inline-block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: '90%'
    }}>
      <strong>
        {transcriptName}
      </strong>
    </span>
  </Link>
  </p>)
}

export default TranscriptExcerptTitle;

